<template>
	<Autocomplete
		v-model="selected"
		:icon="icon"
		:label="label"
		:name="name"
		:endpoint="endpoint"
		data-test="accounts-autocomplete"
		:item-title="
			(item: Api.Account) =>
				multiple
					? item.account_name?.hp_id
					: `${getAccountHpId(item.account_name?.hp_id).value} - ${item.account_name?.name}`
		"
		display-name="Konto"
		module="accounts"
		:multiple="multiple"
		v-bind="$attrs"
	>
		<!--
			Die Zeile bleibt wie gehabt, laesst sich vom Aufrufer aber ersetzen —
			die Belegpruefung zeigt Konten als Cockpit-Zeile mit Nummer, Name und
			Saldo. Ohne eigenen Slot aendert sich fuer alle anderen nichts.
		-->
		<template #item="slotProps">
			<slot name="item" v-bind="slotProps">
				<v-list-item
					:title="`${getAccountHpId(slotProps.item.raw.account_name?.hp_id).value} - ${slotProps.item.raw.account_name?.name}`"
					v-bind="slotProps.props"
				></v-list-item>
			</slot>
		</template>
		<!-- Nur durchreichen, wenn es etwas durchzureichen gibt: sonst verdraengt
			 ein leerer Slot den Suchbegriff-Kopf der Basis. -->
		<template v-if="$slots['prepend-item']" #prepend-item>
			<slot name="prepend-item"></slot>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'
import { getAccountHpId } from 'helpers/FormatValue.ts'

defineProps({
	icon: {
		default: '$accountDefault',
		type: String,
	},
	label: {
		default: 'Konten',
		type: String,
	},
	name: {
		default: 'accounts',
		type: String,
	},
	endpoint: {
		default: 'accounts',
		type: String,
	},
	multiple: {
		default: false,
		type: Boolean,
	},
})

const selected = defineModel<Api.Account>()
</script>

<style scoped></style>
